module.exports = __webpack_public_path__ + "img/mile4.00bbd282.jpg";